import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
} 


export const isIframe = window.self !== window.top;

// Normalizes an entity list()/filter() response into an array, whether the SDK
// returns a plain array (legacy/positional calls) or a paginated page object
// ({ items, next_cursor, has_more }). Prevents blank admin pages when the
// response shape differs from what the loader assumed.
export function toList(res) {
  if (!res) return [];
  if (Array.isArray(res)) return res;
  return Array.isArray(res.items) ? res.items : [];
}